import type { ClientInfo } from '@neosocial/protocol';
import { desktopBridge, isMobileApp } from '../lib/config';
import { thisDevice } from '../lib/device';
import { mobileAppVersion, mobilePlatform } from '../lib/mobile';

/**
 * How Settings › Devices names this session: the browser (on the web) and
 * the system; the phone app is `ios` or `android` (the server keeps those
 * sessions longer). Every request that starts a session sends it: sign-up,
 * sign-in, the two-step step and account recovery.
 */
export function clientInfo(): ClientInfo {
  if (isMobileApp()) {
    const platform = mobilePlatform();
    return {
      client: platform,
      os: platform === 'ios' ? 'iOS' : 'Android',
      app_version: mobileAppVersion(),
    };
  }
  const bridge = desktopBridge();
  const device = thisDevice();
  return {
    client: bridge ? 'desktop' : 'web',
    ...(!bridge && device.browser ? { device_name: device.browser } : {}),
    os: device.os ?? (navigator.platform || undefined),
    app_version: bridge?.appVersion ?? '0.1.0',
  };
}
